import { Api } from "queries/types";
import { useQuery } from "react-query";
import { get } from "./http";

const useFamilyIndex = () => useQuery<Api.Family[]>(["family"], () => get("/families"));

const useFamilyIndexByBrand = (brandId?: number) => useQuery<Api.Family[]>(["family", brandId], () => get("/families",
                                    { params: { 'subFamilies.brands.erpName': brandId } }), { enabled: Boolean(brandId)});

export { useFamilyIndex, useFamilyIndexByBrand };
